import React from 'react';
import {Link} from "react-router-dom";
import ReactDOM from 'react-dom';
import {ShipmentItem} from "./Shipment";
import {Helper} from "./Helper";

export default class ShipmentStockTransfer extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			is_loading: true,
			qs: window.Global.getAllQueryStrings(),
		};
	}

	route() {
		window.Route.on({
			// '/v2/stock_transfer': () => {
			// 	this.setState({
			// 		mode: 'list',
			// 		is_loading: true,
			// 		shipment: false,
			// 		shipments: [],
			// 	}, () => {
			// 		this.fetch();
			// 	})
			// },
			'/v2/stock_transfers/new': () => {
				this.setState({
					mode: 'create',
					is_loading: true,
					shipment: false,
					shipments: [],
				}, () => {
					this.create();
				})
			},
			'/v2/stock_transfers/:stock_transfer_id': (params) => {
				this.setState({
					mode: 'view',
					is_loading: true,
					params: params,
					shipment: false,
					shipments: [],
				}, () => {
					this.view();
				});
			},
			'/v2/stock_transfers/:stock_transfer_id/edit': (params) => {
				this.setState({
					mode: 'edit',
					is_loading: true,
					params: params,
					shipment: false,
					shipments: [],
				}, () => {
					this.edit();
				});
			},
		}).match();
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.location.pathname !== prevProps.location.pathname) {
			this.route();
		} else if (this.props.location.search !== prevProps.location.search) {

		}
	}

	componentDidMount() {
		this.route();
	}

	recalculateItem() {
		window.$('.Item_each').each(function () {
			window.$(this).find('input[name="user_input_quantity"]').trigger('keyup');
		});
	}

	prepare() {
		let $form = window.$(this.$parent);

		$form.find('input[name="responsibility_user_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/user',
			additionalData: {
				limit: 10
			},
			key: 'user',
			template: {
				list: (value) => {
					return window.Mustache.render('<a class="item"><div>{{name}}</div></a>', value);
				},
				selected: {
					text: 'name',
					value: 'id',
					placeholder: 'ไม่ระบุ'
				}
			}
		});

		$form.find('input[name="product_template_id"]').explorer({
			url: process.env.REACT_APP_DOMAIN + '/api/product_template',
			additionalData: () => {
				return {
					limit: 30
				}
			},
			key: 'product_template',
			template: {
				list: (value) => {
					return window.Mustache.render('<div class="item">{{name}}</div>', value);
				},
				selected: {
					display_template: '<div>{{name}}</div>',
					value: 'id',
					placeholder: 'ค้นหากิจกรรมประจำ'
				}
			},
			onSelected: (product_template) => {
				// $form.find('.Item_root').empty();
				product_template.product_template_item.map((product_template_item) => {
					if (window.$('.Item_root').find('div[data-product_id="' + product_template_item.product.id + '"]').length === 0) {
						window.GlobalFunc.reactToDom(
							window.$(this.$parent).find('.Item_root'),
							StockTransferShipmentItem, {
								$parent: window.$(this.$parent),
								mode: 'create',
								shipment_item: {
									...product_template_item,
									id: '',
									quantity_ship: product_template_item.quantity,
									ratio: product_template_item.ratio,
								},
								product: {...product_template_item.product},
								onItemUpdate: this.onItemUpdate,
							}
						);
					}
					return false;
				})
			}
		});

		window.GlobalFunc.setupTag($form.find('input[name="tag[]"]'), {
			type: 'stock_transfer',
			url: process.env.REACT_APP_DOMAIN + '/api/filter',
		});
	}

	create() {
		let response_running_number = [];
		let response_stock;
		window.Global.getDataViaMultiAjax().load({
			'running_number': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/running_number',
				data: {all: true},
				done: function (response) {
					if (!response.success) return false;
					response_running_number = response['running_number'];
				}
			},
			'stock': {
				method: 'GET',
				url: process.env.REACT_APP_DOMAIN + '/api/stock',
				data: {
					limit: 1
				},
				done: function (response) {
					if (!response.success) return false;
					response_stock = response;
				}
			}
		}).done(() => {
			this.setState({
				is_loading: false,
			}, () => {
				window.GlobalFunc.handleCodeInput({
					$node: window.$(this.$parent).find('.RunningNumber_root'),
					$custom_running_number: window.$(this.$parent).find('.custom-running-number'),
					running_number: response_running_number,
					running_number_id: 6
				});
				this.prepare();
				if (typeof response_stock !== 'undefined' && response_stock['stock'].length) {
					window.$.each(response_stock['stock'], (i, stock) => {
						window.$(this.$parent).find('input[name="stock_id"]').explorer('set value', stock);
					});
				}
			});
		});
	}

	edit() {
		let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: {
				shipment_id: this.state.params.stock_transfer_id,
				...data,
			},
			done: (response) => {
				let shipment = response.shipment[0];
				this.setState({
					shipment: shipment,
					is_loading: false,
				}, () => {
					let $form = this.$parent.find('form');
					this.prepare();

					if (shipment['responsibility_user']) {
						$form.find('input[name="responsibility_user_id"]').explorer('set value', shipment['responsibility_user']);
					}

					$form.form2('init', {
						data: shipment
					});

					window.GlobalFunc.setValueTag(
						this.$parent.find('.Explorer[data-explorer_input_name="tag[]"]'),
						shipment['tag']
					);

					setTimeout(() => {
						this.recalculateItem();
					}, 100);
				})
			},
			fail: () => {

			}
		});
	}

	fetch() {
		// alert("Fetch");
		let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: {
				source: "stock_transfer",
				...data,
			},
			done: (response) => {
				this.setState({
					shipments: response.shipment,
					is_loading: false,
				}, () => {
					this.$parent.find('.Table_root').tablePagination({
						disableContent: true,
						data: response.shipment,
						count: response.count,
						onClickPagination: (p) => {
							let qs = window.Global.getAllQueryStrings();
							qs.page = p;
							this.props.history.push(window.Global.getQueryStringLinkFromObject(qs));
						}
					});
				})
			},
			fail: () => {

			}
		});

	}

	view() {
		let data = window.Global.getAllQueryStrings();
		window.Global.ajax({
			method: 'GET',
			url: process.env.REACT_APP_DOMAIN + '/api/shipment',
			data: {
				shipment_id: this.state.params.stock_transfer_id,
				...data,
			},
			done: (response) => {
				this.setState({
					shipment: response.shipment[0],
					is_loading: false,
				})
			},
			fail: () => {

			}
		});
	}

	onItemUpdate() {
		let $parent = window.$('#clear-advance-payment-root');
		let items = $parent.find('form').serializeObject()['item'];
		let summary = window.GlobalFunc.calculateSummary($parent, {
				tax_type: 'none',
				withholding_tax_percent: 0,
				total_price_withholding_tax: 0,
			},
			((items ? items : []).filter(() => {
				return true;
			}))
		);

		window.GlobalFunc.showSummary2(
			$parent.find('.Summary_root'),
			summary,
			{
				tax: false,
				discount: false
			}
		);

		return summary;

	}

	renderView() {
		// console.log(this.state);
		return (
			<div ref={(ref) => {
				this.$parent = ref;
			}} className="main ui container">
				<div id="HeaderTop_root">
					<div className="flex row wrap">
						<div className="ui huge breadcrumb" style={{margin: '0.3em 1.3rem 0 0'}}>
							<Link id="header"
							      className="active section"
							      to={"/v2/stock_transfers"}
							>โอนย้ายสินค้าระหว่างคลัง</Link>
							<span className="divider" style={{margin: '0 1rem'}}>/</span>
							<div className="active section">
								{this.state.shipment ? this.state.shipment.desc : ''}
							</div>
						</div>
						<div className="right floated">
							<Link id="addProductButton" to="/v2/stock_transfers/new"
							      className="ui positive button">โอนย้ายสินค้าระหว่างคลังใหม่</Link>
						</div>
					</div>
				</div>
				<div
					className={this.state.is_table_loading ? "ui form tall padded stacked segment loading" : "ui form tall padded stacked segment"}>
					<div className="flex row center align left content align" style={{padding: '0 0 9px 0'}}>
						<h2 id="title" style={{margin: 0}} className={'text-2xl font-bold'}>
							ใบโอนย้ายสินค้าระหว่างคลัง {this.state.shipment.desc}
						</h2>
						{
							!this.state.shipment.is_deleted ?
								<div className="flex row" data-is_deleted="0"
								     style={{position: 'relative', marginLeft: 'auto'}}>
									{
										!this.state.shipment.is_done
											?
											<div id="approveShipmentStockTransferButton"
											     className="ui basic green button"
											     ref={(ref) => {
												     this.$approveBtn = window.$(ref);
											     }}
											     onClick={() => {
													  this.approve()

												     // if (this.$approveBtn.hasClass("loading")) {
													  //    return false;
												     // }
												     // this.$approveBtn.addClass("loading");
												     //
												     // window.Global.ajax({
													  //    url: process.env.REACT_APP_DOMAIN + '/api/stock_transfer/approve',
													  //    method: 'POST',
													  //    data: {
														//      shipment_id: this.state.shipment.id
													  //    },
													  //    done: (response) => {
														//      this.$approveBtn.removeClass("loading");
												     //
														//      if (response.error) {
														// 	     window.Global.messageTop({
														// 		     type: 'negative',
														// 		     message: response['message'][0]['error_message']
														// 	     });
														// 	     return;
														//      }
														//      if (!response.success) return false;
												     //
														//      window.Global.messageTop({
														// 	     type: 'positive',
														// 	     message: 'อนุมัติใบโอนสินค้าเรียบร้อย'
														//      });
												     //
														//      this.setState({
														// 	     is_loading: true
														//      }, () => {
														// 	     this.view();
														//      })
													  //    }
												     // })
											     }}
											>
												อนุมัติ
											</div>
											: null
									}
									<div className="ui basic gray buttons" style={{margin: "0 0 0 1rem"}}>
										<div id="voidButton"
										     className="ui button"
										     onClick={() => {
											     this.void();
										     }}
										>
											ยกเลิก
										</div>
										<Link id="goToEdit"
										      className="ui button"
										      to={"/v2/stock_transfers/" + this.state.shipment.id + "/edit"}
										>แก้ไข</Link>
										<div id="preview-document-quick-button"
										     className="ui button"
										     data-tooltip="พิมพ์ด่วน (โปรดใช้กับเว็บเบราว์เซอร์เวอร์ชั่นล่าสุด)"
										     data-inverted=""
										     onClick={() => {
											     window.PreviewPdf.open(this.state.shipment, 'stock_transfer', {
												     url: process.env.REACT_APP_DOMAIN + '/api/document',
												     print: true
											     });
										     }}
										>
											<i className="print icon" style={{margin: 0}}></i>
										</div>
										<div id="preview-document-button"
										     onClick={() => {
											     window.PreviewPdf.open(this.state.shipment, 'stock_transfer', {
												     url: process.env.REACT_APP_DOMAIN + '/api/document',
											     });
										     }}
										     className="ui button">พิมพ์เอกสาร
										</div>
									</div>
								</div>
								: null
						}

					</div>
					<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
					<div style={{margin: '0 0 50px 0'}}>
						<div className="flex row padded three column computer">
							<div className="column field">
								<label>วันที่เอกสาร</label>
								<p>{window.Global.getDateThai(this.state.shipment.doc_date, {is_show_time: false})}</p>
							</div>
							<div className="column field">
								<label>วันที่โอนย้าย</label>
								<p>{window.Global.getDateThai(this.state.shipment.done_date, {is_show_time: false})}</p>
							</div>
							<div className="column field">
								<label>พนักงานที่รับผิดชอบ</label>
								<p>{this.state.shipment.responsibility_user ? this.state.shipment.responsibility_user.name : '-'}</p>
							</div>
							<div className="column field">
								<label>โอนออกจากคลัง</label>
								<p>{this.state.shipment.stock ? this.state.shipment.stock.name : '-'}</p>
							</div>
							<div className="column field">
								<label>โอนเข้าคลัง</label>
								<p>{this.state.shipment.stock_2 ? this.state.shipment.stock_2.name : '-'}</p>
							</div>
							<div className="column field">
								<label>สถานะ</label>
								<p dangerouslySetInnerHTML={{__html: this.state.shipment.status_html}}/>
							</div>
							<div className="column field">
								<label>ผู้บันทึกข้อมูล</label>
								<div>
									{
										this.state.shipment.created_user
											? <div>
												{this.state.shipment.created_user.name}
												<br/>
												{window.Global.getDateThai(this.state.shipment.date_created)}
											</div>
											: '-'
									}
								</div>
							</div>
							{
								this.state.shipment.updated_user
									? <div className="column field">
										<label>ผู้แก้ไข</label>
										<p>
											{this.state.shipment.updated_user.name}
											<br/>
											{window.Global.getDateThai(this.state.shipment.date_updated)}
										</p>
									</div>
									: null
							}
							{
								this.state.shipment.approve_user
									? <div className="column field">
										<label>ผู้อนุมัติ</label>
										<p>
											{this.state.shipment.approve_user.name}
											<br/>
											{window.Global.getDateThai(this.state.shipment.date_approved)}
										</p>
									</div>
									: null
							}
							<div className="column field">
								<label>ต้นทุน</label>
								<div className="purchase-order-sourced">
									<div className="each">
										{
											this.state.shipment.cost_purchase_order
												?
												this.state.shipment.cost_purchase_order.map((cost_purchase_order, i) => {
													return (
														<>
															<a href={"/purchase_orders/" + cost_purchase_order.id}>{cost_purchase_order.code} ({cost_purchase_order.relationship.name})</a>
															<br/>
														</>
													)
												})
												: null
										}
									</div>
									{
										!this.state.shipment.is_deleted
											?
											<a className="ui basic button"
											   href={process.env.REACT_APP_DOMAIN + "/purchase_orders/new?source=shipment&reference_id_1=" + this.state.shipment.id}
											>บันทึกต้นทุน</a>
											: null
									}
								</div>
							</div>
						</div>
						<div className="ui dividing header">
							<div>
								<h4>รายการสินค้า</h4>
							</div>
						</div>
						<div className="ui basic table Table_root theme1 td-top-xs">
							<div className="Item_root">
								<div className="thead">
									<div className="tr">
										<div className="th span12">สินค้า</div>
										<div className="th span4">จำนวน</div>
									</div>
								</div>
								<div className="tbody">
									{
										this.state.shipment.shipment_item.map((shipment_item, key) => {
											return (
												<StockTransferShipmentItem
													key={key}
													$parent={window.$(this.$parent)}
													mode="view"
													shipment_item={shipment_item}
													onItemUpdate={this.onItemUpdate}
												/>
											)
										})
									}
								</div>
							</div>
						</div>
					</div>
					<div className="ui grid">
						<div className="sixteen wide mobile sixteen wide tablet eight wide computer column">
							<div style={{maxWidth: '80%'}}>
								<div className="field">
									<label>หมายเหตุ</label>
									<p data-form2_text="">
										{this.state.shipment.remark && this.state.shipment.remark ? this.state.shipment.remark : '-'}
									</p>
								</div>
								<div className="field"
								     ref={(ref) => {
									     window.$(ref).form2('init', {
										     data: this.state.shipment
									     });
								     }}
								>
									<label>ไฟล์แนบ</label>
									<div data-form2_setup="true" data-form2_type="upload"
									     data-input_name="shipment_file_upload"
									     data-remove_input_name="remove_file_upload"
									     data-is_can_remove="false">
										<div className="Upload_fileRoot flex row wrap"/>
									</div>
								</div>
								<div className="field">
									<label>Tags</label>
									<p data-form2_text="">
										{
											this.state.shipment.tag.length > 0 ?
												this.state.shipment.tag.map((tag, tag_i) => {
													let _tag = tag;
													if (tag_i > 0) {
														_tag = "," + tag;
													}
													return _tag;
												})
												: '-'
										}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderList() {
		return (
			<div ref={(ref) => {
				if (!ref) return;
				this.$parent = window.$(ref);
			}}
			     key={'ddd' + window.Global.getRandomInt(1, 99999999)}
			     className="main ui container">
				{/*HEADER*/}
				<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
					<div className="flex row middle-xs center-xs">
						<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
							<Link className="active section" to="/v2/stock_transfers">โอนย้ายสินค้าระหว่างคลัง</Link>
						</div>
					</div>
					<div className="right floated">
						<Link id="addProductButton" to="/v2/stock_transfers/new"
						      className="ui positive button">โอนย้ายสินค้าระหว่างคลังใหม่</Link>
					</div>
				</div>
				{/*SEARCH*/}
				<div id="Search_root" className="box" style={{display: 'none', marginTop: '1rem'}}
				     ref={(ref) => {
					     let $search = window.$(ref);

					     window.Search.init({
						     $node: $search,
						     onSubmit: (data) => {
							     this.props.history.push(window.Global.getQueryStringLinkFromObject(data));
							     return false;
						     }
					     });
					     $search.find('input[name="approve_user_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/user',
						     additionalData: {
							     limit: 30,
							     page: 1,
							     type: 'user'
						     },
						     key: 'user',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });
					     $search.find('input[name="created_user_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/user',
						     additionalData: {
							     limit: 30,
							     page: 1,
						     },
						     key: 'user',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });
					     $search.find('input[name="stock_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/stock',
						     additionalData: {
							     limit: 30,
							     page: 1,
						     },
						     key: 'stock',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });
					     $search.find('input[name="product_template_id"]').explorer({
						     url: process.env.REACT_APP_DOMAIN + '/api/product_template',
						     additionalData: {
							     limit: 30,
							     page: 1,
						     },
						     key: 'product_template',
						     template: {
							     list: '<a class="item flex row">{{name}}</a>',
							     selected: {
								     text: 'name',
								     value: 'id',
								     placeholder: 'ไม่มีระบุ'
							     }
						     }
					     });

				     }}
				>
					<form className="ui form">
						<div className="flex row wrap padded five column computer">
							<div className="column field">
								<label>เลขที่เอกสาร</label>
								<input name="search_query" data-form2_setup="" placeholder={"ค้นหาเลขที่เอกสาร"}/>
							</div>
							<div className="column field">
								<div className="field">
									<label>ช่วงวันที่รับ/จ่ายเช็ค</label>
									<div data-form_calendar="date"
									     data-input_name="start_doc_date"
									     data-placeholder="ช่วงวันที่"
									     data-end_calendar="end_doc_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
							</div>
							<div className="column field">
								<div className="field">
									<label>ถึงวันที่</label>
									<div data-form_calendar="date"
									     data-input_name="end_doc_date"
									     data-placeholder="ถึงวันที่"
									     data-start_calendar="start_doc_date"
									     data-locale="th"
									     data-initialdate=""
									/>
								</div>
							</div>
							<div className="column field">
								<label>จากคลังสินค้า</label>
								<input name="stock_id" data-form2_setup="" placeholder={"จากคลังสินค้า"}/>
							</div>
							<div className="column field">
								<label>สถานะ</label>
								<div className="field">
									<select className="ui dropdown"
									        name="status"
									        data-form2_setup="">
										<option value="all">ทั้งหมด</option>
										<option value="draft">ฉบับร่าง</option>
										<option value="done">สมบูรณ์</option>
										<option value="void">ยกเลิก</option>
									</select>
								</div>
							</div>
							<div className="column field">
								<label>ผู้บันทึกข้อมูล</label>
								<input name="created_user_id" data-form2_setup="" placeholder={"ผู้บันทึก"}/>
							</div>
							<div className="column field">
								<label>ผู้บันทึกอนุมัติ</label>
								<input name="approve_user_id" data-form2_setup="" placeholder={"ผู้บันทึกอนุมัติ"}/>
							</div>
							<div className="column field">
								<label>กิจกรรมประจำ</label>
								<input name="product_template_id" data-form2_setup="" placeholder={"กิจกรรมประจำ"}/>
							</div>
							<div className="column fluid right floated">
								<label style={{opacity: 0}}>อื่นๆ</label>
								<div className="flex row wrap right floated end-xs">
									<button className="ui icon button" type="submit">
										<i className="search icon"/> ค้นหา
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
				{/*TABLE*/}
				<div className="flex row wrap">
					<div className="ui basic table can click Table_root td-top-xs" style={{marginTop: '1rem'}}>
						<div className="thead">
							<div className="tr">
								<div className="th span4">เลขที่</div>
								<div className="th span4">วันที่เอกสาร</div>
								<div className="th span4">คลังสินค้า</div>
								<div className="th span4">พนักงานที่รับผิดชอบ</div>
								<div className="th span4">สถานะ</div>
							</div>
						</div>
						<div className="tbody">
							{
								this.state.is_loading
									? <div className="tr">
										<div className="td center aligned" data-info="nodata">
											<div className="ui active centered inline small loader"/>
										</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.shipments.length === 0
								&& (
									!window.Global.getAllQueryStrings().page
									|| window.Global.getAllQueryStrings().page === '1'
								) ?
									<div className="tr">
										<div className="td span16" style={{textAlign: 'center'}}>ไม่พบข้อมูล</div>
									</div>
									: null
							}
							{
								!this.state.is_loading
								&& this.state.shipments.length > 0 ?
									this.state.shipments.map((shipment, shipment_i) => {
										return (
											<Link to={"/v2/stock_transfers/" + shipment.id} className="tr"
											      key={shipment_i}>
												<div className="td span4">
													{shipment.desc}
												</div>
												<div className="td span4">
													{window.Global.getDateThai(shipment.doc_date, {is_show_time: false})}
												</div>
												<div className="td span4">
													{shipment.stock ? shipment.stock.name : ""}
												</div>
												<div className="td span4">
													{shipment.responsibility_user ?
														shipment.responsibility_user.name
														: null
													}
												</div>
												<div className="td span4">
													<div
														dangerouslySetInnerHTML={{__html: shipment.status_html}}/>
												</div>
											</Link>
										)
									}) : null
							}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.is_loading) {
			return <div className="ui active centered inline loader"/>
		}

		if (this.state.mode === 'list') {
			return this.renderList();
		}

		if (this.state.mode === 'view' && this.state.shipment) {
			return this.renderView();
		}

		return (
			<>
				<div key={'ddd' + window.Global.getRandomInt(1, 99999999)}
				     ref={(ref) => {
					     if (!ref) return;
					     this.$parent = window.$(ref);
				     }}
				     className="main ui container">
					{/*HEADER*/}
					<div id="HeaderTop_root" className="flex row wrap" style={{marginBottom: '1rem'}}>
						<div className="flex row middle-xs center-xs">
							<div className="ui huge breadcrumb" style={{margin: '0 1em 0 0'}}>
								<Link className="active section" to="/v2/stock_transfers">โอนย้ายสินค้าระหว่างคลัง</Link>
								{
									this.state.shipment
										? <>
											<span className="divider" style={{margin: '0 1rem'}}>/</span>
											<Link to={"/v2/stock_transfers/" + this.state.shipment.id}
											      className="section">
												{this.state.shipment ? this.state.shipment.desc : ''}
											</Link>
										</>
										: null
								}
								<span className="divider" style={{margin: '0px 1rem'}}>/</span>
								<div className="section active">{this.state.mode === "create" ? "ใหม่" : "แก้ไข"}</div>
							</div>
						</div>
						<div className="right floated">
							<Link id="addProductButton"
							      to="/v2/stock_transfers/new"
							      className="ui positive button">
								สร้างโอนย้ายสินค้าระหว่างคลัง
							</Link>
						</div>
					</div>
					{/*SEARCH*/}
					<form id="ShipmentStockTransfer_root"
					      ref={(ref) => {
						      window.$(ref).form2('setup');
						      window.$(ref).form2('submit', {
							      method: this.state.mode === 'create'
								      ? 'POST'
								      : 'PUT',
							      url: process.env.REACT_APP_DOMAIN + '/api/stock_transfer',
							      beforeSent: (object) => {
								      object = window.Explorer.getData(window.$(ref), object);
								      return object;
							      },
							      loadingButton: window.$(this.$parent).find('#submit-button'),
							      onSuccess: (response) => {
								      window.Global.messageTop({
									      type: 'positive',
									      message: 'บันทึกข้อมูลเรียบร้อย'
								      });
								      // console.log(response);
								      if (this.state.mode === 'edit') {
									      this.props.history.push({
										      pathname: '/v2/stock_transfers/' + this.state.shipment.id,
										      state: null
									      });
								      }
								      if (this.state.mode === 'create') {
									      this.props.history.push({
										      pathname: '/v2/stock_transfers/' + response.shipment_id,
										      state: null
									      });
								      }
							      }
						      });
					      }}
					      className={
						      this.state.is_loading
							      ? "ui form ui tall stacked loading segment"
							      : "ui form ui tall stacked segment"
					      }
					      autoComplete="off">
						<div className="flex row wrap middle-xs Signature_head" style={{padding: '2px 0 14px 0'}}>
							<h2 style={{margin: 0}} className={'text-2xl font-bold'}>
								{this.state.mode === 'edit' ? 'แก้ไข' : null}
								โอนย้ายสินค้าระหว่างคลัง
							</h2>
						</div>
						<div className="ui divider" style={{margin: '0 0 14px 0'}}/>
						<div className={"flex row wrap padded three column computer"}>
							<div className="column field required custom-running-number">
								<label className="flex row">
									เลขที่เอกสาร
									{
										this.state.mode === 'create'
											? <span className="ui checkbox"
											        data-form2_setup="true"
											        style={{marginLeft: '0.5rem'}}>
											      <input type="checkbox"
											             tabIndex="-1"
											             className="hidden"
											             name="is_code_generate_auto"
											             id={"is_code_generate_auto"}
											             defaultChecked="checked"
											      />
											      <label htmlFor="is_code_generate_auto"
											             style={{paddingLeft: '1.5em'}}>Auto</label>
										      </span>
											:
											null
									}
								</label>
								<input type="text" name={
									this.state.shipment
										? "shipment_no"
										: "shipment_no"
								}
								/>
							</div>
							<div className="column field required">
								<label>วันที่เอกสาร</label>
								<div data-form_calendar="date"
								     data-input_name="doc_date"
								     data-placeholder={"วันที่เอกสาร"}
								     data-locale="th"
								     data-initialdate={"now"}
								/>
							</div>
							<div className="column field required">
								<label>วันที่โอนย้าย</label>
								<div data-form_calendar="date"
								     data-input_name="done_date"
								     data-placeholder={"วันที่โอนย้าย"}
								     data-locale="th"
								     data-initialdate={"now"}
								/>
							</div>
							<div className="column field required">
								<label>โอนออกจากคลังสินค้า</label>
								{
									this.state.mode === 'create'
									|| (
										this.state.mode === 'edit'
										&& this.state.shipment.is_done === 0
									)
										? <input name={"stock_id"}
										         ref={(ref) => {
											         let $e = window.$(ref).explorer({
												         url: process.env.REACT_APP_DOMAIN + '/api/stock',
												         additionalData: () => {
													         return {
														         limit: 30,
														         page: 1
													         }
												         },
												         key: 'stock',
												         template: {
													         list: '<a class="item flex row">{{name}}</a>',
													         selected: {
														         text: 'name',
														         value: 'id',
														         placeholder: 'ค้นหาคลังสินค้า'
													         }
												         },
												         onSelected: (stock) => {
													         if (stock.id === parseInt(this.$parent.find('input[name="stock_2_id"]').val())) {
														         this.$parent.find('input[name="stock_2_id"]').explorer('clear');
													         }

													         window.$('.Item_each').each(function () {
														         // console.log(window.$(this).find('input[name="serial_number[]"]').closest('.Explorer'));
														         window.$(this).find('input[name="serial_number[]"]').closest('.Explorer').explorer('clear');
													         });

													         this.$parent.find('input[name="product_template_id"]').explorer('clear');
													         //this.$parent.find('.Item_each').remove();
													         this.recalculateItem();
												         },
												         onUnSelected: () => {
													         this.recalculateItem();
												         }
											         });

											         if (this.state.mode === 'edit'
												         && this.state.shipment.is_done === 0
											         ) {
												         $e.explorer('set selected', this.state.shipment.stock);
											         }
										         }}

										/>
										: this.state.shipment.stock.name
								}
							</div>
							<div className="column field required">
								<label>โอนเข้าคลังสินค้า</label>
								{
									this.state.mode === 'create'
									|| (
										this.state.mode === 'edit'
										&& this.state.shipment.is_done === 0
									)
										? <input name={"stock_2_id"}
										         ref={(ref) => {
											         let $e = window.$(ref).explorer({
												         url: process.env.REACT_APP_DOMAIN + '/api/stock',
												         additionalData: () => {
													         return {
														         limit: 30,
														         page: 1,
														         exclude_stock_id: this.$parent.find('input[name="stock_id"]').val()
													         }
												         },
												         key: 'stock',
												         template: {
													         list: '<a class="item flex row">{{name}}</a>',
													         selected: {
														         text: 'name',
														         value: 'id',
														         placeholder: 'ค้นหาคลังสินค้า'
													         }
												         },
												         onSelected: () => {
													         this.$parent.find('input[name="product_template_id"]').explorer('clear');
													         // this.$parent.find('.Item_each').remove();
													         this.recalculateItem();
												         },
												         onUnSelected: () => {
													         this.recalculateItem();
												         }
											         });

											         if (this.state.mode === 'edit'
												         && this.state.shipment.is_done === 0
											         ) {
												         $e.explorer('set selected', this.state.shipment.stock_2);
											         }
										         }}
										/>
										: this.state.shipment.stock.name
								}
							</div>
							{
								this.state.mode === 'create'
									? <div className="column field required">
										<label>กิจกรรมประจำ</label>
										<input name={"product_template_id"}/>
									</div>
									: null
							}
							<div className="column field required">
								<label>พนักงานที่รับผิดชอบ</label>
								<input name={"responsibility_user_id"}/>
							</div>
							{
								(
									this.state.mode === 'create'
									||
									(
										this.state.shipment
										&& this.state.shipment.id
										&& this.state.shipment.is_done === 0
									)
								)
								&&
								<div className="column field">
									<label>อื่นๆ</label>
									<div className="ui checkbox" data-form2_setup="true">
										<input id="is_disable_quantity_checking_on_origin_stock"
										       type="checkbox"
										       tabIndex="-1"
										       className="hidden"
										       name="is_disable_quantity_checking_on_origin_stock"
										/>
										<label htmlFor="is_disable_quantity_checking_on_origin_stock">
										<span
											data-tooltip={'กรณีไม่มียอดที่คลังต้นทางเพียงพอ สามารถโอนย้ายออกจากคลังได้ (โดยทั่วไปไม่แนะนำให้ติ๊กช่องนี้ โปรดระมัดระวังการกระทำนี้)'}
											data-inverted={true}
										>
											ไม่ตรวจสอบจำนวนคลังต้นทาง
										</span>
										</label>
									</div>
								</div>
							}
						</div>
						<br/>
						<div className="flex row padded wrap one column computer">
							<div className="column">
								<h4 className="ui dividing header">รายละเอียด</h4>
								<div className="ui basic table Table_root theme1 td-top-xs">
									<div className="thead">
										<div className="tr">
											{
												this.state.shipment.is_done
													?
													<>
														<div className="th span12">สินค้า</div>
														<div className="th span4">จำนวน</div>
													</>
													:
													<>
														<div className="th span5 half">สินค้า</div>
														<div className="th span2">คลังออกมีอยู่</div>
														<div className="th span2">คลังออกหลังโอน</div>
														<div className="th span2 half">จำนวนที่โอน</div>
														<div className="th span2">คลังเข้ามีอยู่</div>
														<div className="th span2">คลังเข้าหลังโอน</div>
													</>
											}
										</div>
									</div>
									<div className="tbody Item_root">
										{
											this.state.mode === 'edit'
												?
												this.state.shipment.shipment_item.map((shipment_item, key) => {
													if (this.state.shipment.is_done) {
														return <StockTransferShipmentItem
															key={key}
															$parent={window.$(this.$parent)}
															mode="view"
															shipment_item={shipment_item}
															onItemUpdate={this.onItemUpdate}
														/>
													}

													return (
														<StockTransferShipmentItem
															key={key}
															$parent={window.$(this.$parent)}
															mode="edit"
															shipment={this.state.shipment}
															shipment_item={shipment_item}
															onItemUpdate={this.onItemUpdate}
															// isApprove={this.state.payment.is_approve}
														/>
													)
												})
												: null
										}
									</div>
									{
										!this.state.shipment.is_done
											?
											<div className="tr">
												<div className="td flex span16 center-xs">
													<div>
														<div className="ui basic button"
														     id="newItemButton"
														     onClick={() => {
															     window.GlobalFunc.reactToDom(
																     window.$(this.$parent).find('.Item_root'),
																     StockTransferShipmentItem, {
																	     $parent: window.$(this.$parent),
																	     mode: 'create',
																	     shipment_item: {
																		     quantity: 1,
																		     ratio: 1,
																		     price: 0,
																	     },
																	     onItemUpdate: this.onItemUpdate,
																     }
															     );
														     }}
														>
															<i className="plus icon"/>
															เพิ่มรายการ
														</div>
													</div>
												</div>
											</div>
											: null
									}
								</div>
							</div>
						</div>
						<div className="flex row wrap">
							<div className="col-xs-16 col-lg-11">
								<div style={{maxWidth: '50%'}}>
									<div className="field">
										<label>หมายเหตุ</label>
										<textarea className="ui dropdown" name="remark"/>
									</div>
									<div className="field">
										<label>ไฟล์แนบ</label>
										<div id="Upload_fileRoot"
										     data-form2_setup="done" data-form2_type="upload"
										     data-input_name="shipment_file_upload"
										     data-remove_input_name="remove_file_upload"
										     data-is_can_remove="true"
										/>
									</div>
									<div className="field">
										<label>Tags</label>
										<input type="text" name="tag[]"/>
									</div>
								</div>
							</div>
						</div>
						<br/>
						<br/>
						<div className="ui error message"/>
						<div className="flex row">
							<div className="right floated">
								{
									this.state.shipment && this.state.shipment.id ?
										<input type={"hidden"} name={"shipment_id"}
										       defaultValue={this.state.shipment.id}/>
										: null
								}
								<input type={"hidden"}
								       name={"is_done"}
								       defaultValue={this.state.shipment ? this.state.shipment.is_done : 1}
								/>
								<Link
									to={
										this.state.mode === 'create'
											? '/v2/stock_transfers'
											: '/v2/stock_transfers/' + this.state.shipment.id
									}
									className={"ui button"}>ยกเลิก</Link>
								{
									this.state.mode === 'create' ?
										<button id="submitDraftButton"
										        className="ui button"
										        type="button"
										        onClick={() => {
											        let $form = this.$parent.find('form');
											        $form.find('input[name="is_done"]').val(0);
											        $form.trigger('submit');
										        }}
										>
											บันทึกฉบับร่าง
										</button>
										: null
								}
								<button id="submitButton" className="ui positive button" type="submit">
									{this.state.mode === 'create' ? 'บันทึกและอนุมัติโอนย้ายสินค้าระหว่างคลัง' : null}
									{this.state.mode === 'edit' ? 'บันทึก' : null}
								</button>
							</div>
						</div>
					</form>
				</div>
			</>
		);
	}

	void() {
		window.Global.confirm({
			title: 'ยืนยันยกเลิกใบโอนย้ายสินค้า',
			content: '<form class="ui form">\n\t<p>โปรดยืนยันลบข้อมูล การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n    <div class="column field">\n        <div class="ui checkbox" data-form2_setup="true">\n            <input id="is_disable_quantity_checking_on_origin_stock"\n                   type="checkbox"\n                   tabIndex="-1"\n                   class="hidden"\n                   name="is_disable_quantity_checking_on_origin_stock"\n            />\n            <label for="is_disable_quantity_checking_on_origin_stock">\n                <span data-tooltip="กรณีไม่มียอดที่คลังปลายทางเพียงพอ สามารถยกเลิกใบโอนย้ายได้ (โดยทั่วไปไม่แนะนำให้ติ๊กช่องนี้ โปรดระมัดระวังการกระทำนี้)"\n                      data-inverted\n                >ไม่ตรวจสอบจำนวนคลังต้นปลายทาง</span>\n            </label>\n        </div>\n    </div>\n\t<div class="ui error message"></div>\n</form>',
			cancel_text: 'ไม่ดำเนินการ',
			approve_text: 'ยกเลิกใบโอนย้ายสินค้า',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'DELETE',
					url: process.env.REACT_APP_DOMAIN + '/api/stock_transfer',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.shipment_id = this.state.shipment.id;
						return data;
					},
					onSuccess: () => {
						$modal.modal('hide');
						window.Global.messageTop({
							type: 'positive',
							message: 'ลบข้อมูลสำเร็จ'
						});
						this.view();
					}
				});
			}
		});
	}

	approve() {
		window.Global.confirm({
			title: 'ยืนยันอนุมัติ',
			content: '<form class="ui form">\n    <p>ยืนยันการอนุมัติโอนย้ายสินค้า การกระทำนี้ไม่สามารถกู้ข้อมูลคืนได้</p>\n    <div class="column field">\n        <div class="ui checkbox" data-form2_setup="true">\n            <input id="is_disable_quantity_checking_on_origin_stock"\n                   type="checkbox"\n                   tabIndex="-1"\n                   class="hidden"\n                   name="is_disable_quantity_checking_on_origin_stock"\n            />\n            <label for="is_disable_quantity_checking_on_origin_stock">\n                <span data-tooltip="กรณีไม่มียอดที่คลังต้นทางเพียงพอ สามารถโอนย้ายออกจากคลังได้ (โดยทั่วไปไม่แนะนำให้ติ๊กช่องนี้ โปรดระมัดระวังการกระทำนี้)"\n                      data-inverted\n                >ไม่ตรวจสอบจำนวนคลังต้นทาง</span>\n            </label>\n        </div>\n    </div>\n    <div class="ui error message"></div>\n</form>',
			cancel_text: 'ยกเลิก',
			approve_text: 'อนุมัติใบโอนย้ายสินค้า',
			onShowToSetupForm: ($modal) => {
				$modal.find('form').form2('setup');
				$modal.find('form').form2('submit', {
					method: 'POST',
					url: process.env.REACT_APP_DOMAIN + '/api/stock_transfer/approve',
					loadingButton: $modal.find('.button.approve'),
					beforeSent: (data) => {
						data.shipment_id = this.state.shipment.id;
						return data;
					},
					onSuccess: () => {
						$modal.modal('hide');

						window.Global.messageTop({
							type: 'positive',
							message: 'อนุมัติใบโอนสินค้าเรียบร้อย'
						});

						this.setState({
							is_loading: true
						}, () => {
							this.view();
						})
					}
				});
			}
		});
	}
}

class StockTransferShipmentItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mode: props.mode,
			id: props.shipment_item.id || '',
			description: props.shipment_item.description || '',
			quantity_ship: props.shipment_item.quantity_ship || '',
			ratio: props.shipment_item.ratio || '',
			product: props.shipment_item.product || false,
			shipment_item_serial_number: props.shipment_item.shipment_item_serial_number || [],
		};
	}

	componentDidMount() {
		window.$(this.ref).find('textarea[name="item[][description]"]').autoHeight();
		this.onChange();
	}

	remove() {
		window.$(this.ref).remove();
		this.onChange();
	}

	onChange() {
		this.props.onItemUpdate();
	}

	renderView() {
		return (
			<div
				ref={(ref) => {
					this.ref = ref;
				}}
				className="tr Item_each"
			>
				<div className="td span12">
					{
						this.state.mode === 'view' &&
						<ShipmentItem shipment_item={this.props.shipment_item}/>
					}
				</div>
				<div className="td span4">
					<div className="flex row">
						<div>
							{window.GlobalFunc.getUnitNameByQuantity2({
								product: this.props.shipment_item['product'],
								quantity: this.props.shipment_item['quantity_ship'],
								ratio: this.props.shipment_item['ratio']
							})['text']}
						</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		if (this.state.mode === 'view') {
			return this.renderView();
		}

		if (this.state.mode === 'create') {
			let stock_id = parseInt(this.props.$parent.find('input[name="stock_id"]').val());
			let stock_2_id = parseInt(this.props.$parent.find('input[name="stock_2_id"]').val());
			if (!stock_id || !stock_2_id) {
				this.props.$parent.find('.ui.error.message').text('เลือกคลังออกและเข้าให้ต่างกัน');
				this.props.$parent.find('#newItemButton')
					.popup({
						on: 'click',
						content: 'ระบุคลังสินค้า'
					})
					.popup('show');
				return null;
			} else {
				this.props.$parent.find('#newItemButton').popup('destroy');
			}
		}

		return (
			<div data-product_id={this.state.product.id}
			     ref={(ref) => {
				     if (!ref) return;
				     this.$item = window.$(ref);
			     }}
			     className="tr Item_each"
			>
				<div className="td span5 half">
					<div>
						{
							!this.state.product
								?
								<div ref={(ref) => {
									let $e = window.$(ref).find('input[name="search_product_name"]').explorer({
										url: process.env.REACT_APP_DOMAIN + '/api/product',
										additionalData: () => {
											let $parent = $e.closest('#ShipmentStockTransfer_root');

											let exclude_product_id = [];
											window.$('input[name="item[][product_id]"]').each((i, e) => {
												exclude_product_id.push(window.$(e).val());
											});

											return {
												page: 1,
												limit: 30,
												for: 'stock_transfer',
												from_stock_id: $parent.find('input[name="stock_id"]').val(),
												to_stock_id: $parent.find('input[name="stock_2_id"]').val(),
												product_serial_number: true,
												stock_id: $parent.find('input[name="stock_id"]').val(),
												exclude_product_id: exclude_product_id.join(',')
											}
										},
										key: 'product',
										template: {
											list: (value) => {
												let search = $e.val();
												return window.GlobalTemplate.getProductSearchList(search, value);
											},
											selected: {
												text: 'name',
												value: 'id',
												placeholder: ''
											}
										},
										onSelected: (product) => {
											this.setState({
												product: product,
												quantity_ship: product.sell_price[0].ratio,
												ratio: product.sell_price[0].ratio,
											}, () => {
												// if (window.$('.Item_root').find('div[data-product_id="' + this.state.product['id'] + '"]').length > 1) {
												//    window.$(this.ref).remove();
												//    return false;
												// }
											})
										}
									});
									setTimeout(() => {
										this.$item.find('input[name="search"]').focus();
									}, 100);
								}}>
									<input type="text"
									       name="search_product_name"
									       placeholder="สินค้า"
									/>
								</div>
								: null
						}
						{
							/*
							หลังเลือกสินค้าแล้ว
							 */
							this.state.product
								?
								<div className="flex row">
									<img className="ui avatar image"
									     src={this.state.product.product_image_file_upload.url}
									     alt={"Product"}
									/>
									<div className="product">
										<div className="product-name">{this.state.product.name}</div>
										{
											this.state.product.is_serial_number
												?
												<div className="serial-number"
												     style={{
													     marginTop: '5px'
												     }}>
													<input type="text"
													       name="serial_number[]"
													       ref={(ref) => {
														       let $e = window.$(ref).explorer({
															       url: process.env.REACT_APP_DOMAIN + '/api/product_serial_number',
															       multiple: true,
															       additionalData: () => {
																       let $parent = $e.closest('#ShipmentStockTransfer_root');

																       return {
																	       page: 1,
																	       limit: 30,
																	       product_id: this.state.product.id,
																	       product_serial_number: true,
																	       store_in_stock_id: $parent.find('input[name="stock_id"]').val(),
																	       exclude_product_serial_number_id: $e.explorer('get value')
																       }
															       },
															       key: 'product_serial_number',
															       template: {
																       list: (value) => {
																	       let search = $e.find('input[name="search"]').val();
																	       return window.GlobalTemplate.getProductSerialNumberSearchList(search, value);
																       },
																       selected: {
																	       text: 'serial_number',
																	       value: 'id',
																	       placeholder: 'ค้นหา Serial Number'
																       }
															       },
															       onSelected: () => {
																       this.$item.find('input[name="user_input_quantity"]')
																	       .val($e.explorer('get value').length)
																	       .trigger('keyup');
															       },
															       onUnSelected: () => {
																       this.$item.find('input[name="user_input_quantity"]')
																	       .val($e.explorer('get value').length)
																	       .trigger('keyup');
															       }
														       });

														       if (this.state.mode === 'edit') {
															       setTimeout(() => {
																       for (let shipment_item_serial_number of this.state.shipment_item_serial_number) {
																	       $e.explorer('set value', shipment_item_serial_number.product_serial_number);
																       }
															       }, 100);
														       }
													       }}
													/>
												</div>
												: null
										}
									</div>
									<input type="hidden" name="item[][product_id]" value={this.state.product.id}/>
								</div>
								: null
						}
					</div>
				</div>
				<div className="td span2">
					<div className="Item_quantityAfter1"/>
				</div>
				<div className="td span2">
					<div className="Item_quantityAfter2"/>
				</div>
				<div className="td span2 half">
					<div className="flex row">
						<div>
							{
								this.state.product
									?
									<div>
										<div ref={(ref) => {
											window.GlobalFunc.setupQuantityAndRatio(window.$(ref), {
												product: this.state.product,
												quantity: this.state.quantity_ship,
												input_quantity: 'item[][quantity_ship]',
												ratio: this.state.ratio,
												input_ratio: 'item[][ratio]',
												quantityReadOnly: false,
												allowNegative: false,
												rootClass: '',
												onChange: (item, $e) => {
													setTimeout(() => {
														let $parent = $e.closest('form');
														let $item = $e.closest('.Item_each');

														let stock_id = $parent.find('input[name="stock_id"]').val();
														let stock_2_id = $parent.find('input[name="stock_2_id"]').val();

														$item.find('input[name="item[][quantity_ship]"]').val(item.quantity);
														// calculate after quantity 1
														let stock1 = Helper.getProductStock(this.state.product, stock_id);
														$item.find('.Item_quantityAfter1').text(window.GlobalFunc.getUnitNameByQuantity(this.state.product, stock1.on_hand)['text']);
														$item.find('.Item_quantityAfter2').text(window.GlobalFunc.getUnitNameByQuantity(this.state.product, (stock1.on_hand - item.quantity))['text']);

														// calculate after quantity 2
														let stock2 = Helper.getProductStock(this.state.product, stock_2_id);
														$item.find('.Item_quantityAfter3').text(window.GlobalFunc.getUnitNameByQuantity(this.state.product, stock2.on_hand)['text']);
														$item.find('.Item_quantityAfter4').text(window.GlobalFunc.getUnitNameByQuantity(this.state.product, (item.quantity + stock2.on_hand))['text']);
													});
												}
											});

											if (this.state.product.is_serial_number) {
												window.$(ref).find('.Item_selectUnitName').addClass('active');
												window.$(ref).find('.Item_selectUnitName').dropdown('set selected', '0');
												window.$(ref).find('input[name="user_input_quantity"]')
													.val(0)
													.attr('readonly', 'readonly')
													.trigger('keyup');
											}
										}}
										/>
									</div>
									: '-'
							}
						</div>
					</div>
				</div>
				<div className="td span2">
					<div className="Item_quantityAfter3">-</div>
				</div>
				<div className="td span2">
					<div className="flex row between-xs">
						<div className="Item_quantityAfter4">-</div>
						<input type="hidden" name="item[][is_deleted]" value={0}/>
						<input type="hidden" name="item[][id]" value={this.state.id || ''}/>
						<div className="ui icon button right floated remove"
						     onClick={() => {
							     if (!this.state.id) {
								     this.$item.remove();
								     ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this));
							     } else {
								     this.$item.addClass('disabled');
								     this.$item.find('input[name="item[][is_deleted]"]').val(1);
							     }
						     }}>
							<i className="remove icon"/>
						</div>
					</div>
				</div>
				<div className="disabled-wrapper flex row middle-xs">
					<div className="right floated">
						<div className="ui button basic"
						     onClick={() => {
							     this.$item.removeClass('disabled');
							     this.$item.find('input[name="item[][is_deleted]"]').val(0);
						     }}>
							ย้อนกลับ
						</div>
					</div>
				</div>
			</div>
		);
	}
}
